<template>
  <div class="page-wrap p-3">
    <div class="page-header p-3 mb-3 mt-3">
      <h3>Отчет на 1С</h3>
      <div class="add-item-block mt-3 mb-3 d-flex justify-content-end">
        <b-button variant="success"
                  v-if="isAdmin() || isAccountant()"
                  @click="onClickImport()">
          Сформировать отчет
        </b-button>
      </div>
    </div>
  </div>

  <!-- Modal component -->
  <b-modal v-model="showModal" title="Отчет" @ok="submitForm">
    <form @submit.prevent="submitForm" class="mb-4">
      <div class="mb-3">
        <label for="reportType" class="form-label">
          Тип отчета
        </label>
        <select v-model="dialog.filter.reportType" id="reportType" required
                class="form-select">
          <option v-for="(type, key) in reportTypes" :key="key" :value="key">
            {{ type }}
          </option>
        </select>
      </div>

      <div class="mb-3">
        <label for="trancheYear" class="form-label">
          Год
        </label>
        <select v-model="dialog.filter.trancheYear" id="trancheYear" required
                class="form-select">
          <option v-for="(year, index) in trancheYears" :key="index" :value="year">
            {{ year }}
          </option>
        </select>
      </div>

      <div class="mb-3">
        <label for="trancheNumber" class="form-label">
          Номер транша
        </label>
        <select v-model="dialog.filter.trancheNumber" id="trancheNumber"
                class="form-select" required>
          <option v-for="(trancheNumber, index) in trancheNumbers" :key="index" :value="trancheNumber">
            {{ trancheNumber }}
          </option>
        </select>
      </div>

      <div class="mb-3">
        <label for="approveDate" class="form-label">
          Дата утверждения акта
        </label>
        <input
            id="approveDate"
            type="date"
            v-model="dialog.filter.approveDate"
            class="form-control"/>
      </div>
    </form>
  </b-modal>

  <vue-loading :active.sync="isLoading" :is-full-page="true"></vue-loading>
</template>

<script>

import VueLoading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';
import {showErrorNotify, showSuccessNotify} from "@/utils/notificationUtils";
import settingsService from "@/services/settingsService";
import authService from "@/services/authService";
import delegationService from "@/services/delegationService";
import reportService from "@/services/reportService";
import {ReportTypeEnum} from "@/enum/ReportTypeEnum";
import {UniversityEnum} from "@/enum/UniversityEnum";

export default {
  components: {
    VueLoading
  },
  data() {
    const currentUserUniversityInfo = JSON.parse(localStorage.getItem("currentUserUniversityInfo") || "{}");

    console.log(currentUserUniversityInfo, 'TEST 5555');
    debugger;
    const filteredReportTypes = Object.fromEntries(
        Object.entries(ReportTypeEnum)
            .filter(([key, value]) => {

              if (key === 'ECO_PAYMENT_REPORT') {
                return currentUserUniversityInfo.universityId === UniversityEnum.KORKYT_ATA_KYZYLORDA_UNIVERSITY.id;
              }
              return true;
            })
            .map(([key, value]) => [key, value.nameRu])
    );

    return {
      isLoading: false,
      showModal: false,
      setting: {
        defaultTrancheYear: null,
        defaultTrancheNumber: null
      },
      dialog: {
        filter: {
          trancheYear: null,
          trancheNumber: null,
          approveDate: null,
          reportType: ReportTypeEnum.STATE_ORDER.code,
        }
      },
      trancheYears: Array.from({length: 7}, (v, i) => 2024 + i),
      trancheNumbers: Array.from({length: 4}, (v, i) => 1 + i),
      adminRoles: authService.getAdminRoles(),
      managerRoles: authService.getManagerRoles(),
      universityManagerRoles: authService.getUniversityManagerRoles(),
      reportTypes: filteredReportTypes
    };
  },
  methods: {
    init() {
      this.initSettings().then(response => {
        this.dialog.filter.trancheYear = this.setting.defaultTrancheYear;
        this.dialog.filter.trancheNumber = this.setting.defaultTrancheNumber;
      });
    },
    async submitForm() {
      this.isLoading = true;

      try {
        await reportService.generateReport1C(this.dialog);

        this.showModal = false;
      } catch (error) {
        showErrorNotify(error);
      } finally {
        this.isLoading = false;
      }
    },
    async onClickImport() {
      this.uploadedFile = null;

      this.dialog.filter.trancheYear = this.setting.defaultTrancheYear;
      this.dialog.filter.trancheNumber = this.setting.defaultTrancheNumber;

      this.showModal = true;
    },

    isAdmin() {
      return delegationService.isAdmin();
    },
    isManagerFC() {
      return delegationService.isManagerFC();
    },

    isUniversityManager() {
      return delegationService.isUniversityManager();
    },

    isAccountant() {
      return delegationService.isAccountant();
    },
    async initSettings() {
      this.setting = await settingsService.load();
    },
  },
  mounted() {
    this.init();
  }
};
</script>

<style scoped>
.row {
  padding-top: 5px;
}

.ascending {
  background-image: url("../assets/asc.svg") !important;
}

.descending {
  background-image: url("../assets/desc.svg") !important;
}

.none {
  background-image: url("../assets/none.svg");
  margin-left: 10px !important;
}

.sortable-container {
  background-position: right calc(0.75rem / 2) center;
  background-repeat: no-repeat;
  background-size: 0.65em 1em;
  vertical-align: middle !important;
  margin-right: 10px !important;
  padding-right: 15px !important;
  cursor: pointer;
}

th div {
  width: 100% !important;
  display: grid !important;
}

.p-3 {
  padding: 0 !important;
}

.action-cell {
  display: flex;
  justify-content: flex-end;
}

.delete-button {
  display: flex;
  align-items: center;
}

</style>
